<div class="container-header">
  แสดงความคิดเห็น
</div>
<div class="container-detail">
  <div class="title-text sub-header-font-size">
    ท่านสามารถแสดงความคิดเห็นเกี่ยวกับการใช้งานระบบ TL Smart claim เพ่ือนำไปพัฒนาระบบ
  </div>
  <form nz-form [formGroup]="form">
    <div nz-row class="mt-30">
      <nz-form-item nz-col nzXs="24" nzLg="4" nzXl="4" nzXXl="4">
        <div class="label-input body-font-size">เมนู :</div>
      </nz-form-item>
      <nz-form-item nz-col nzXs="24" nzLg="20" nzXl="20" nzXXl="20">
        <nz-form-control [nzErrorTip]="">
          <nz-select class="body-font-size" style="width: 30%;" nzPlaceHolder="เลือกเมนู" formControlName="menu">
            <nz-option class="body-font-size" *ngFor="let item of menu" [nzLabel]="item.menuNameTh"
              [nzValue]="item.menuId">
            </nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-row>
      <nz-form-item nz-col nzXs="24" nzLg="4" nzXl="4" nzXXl="4">
        <div class="label-input body-font-size">ความคิดเห็น :</div>
      </nz-form-item>
      <nz-form-item nz-col nzXs="24" nzLg="20" nzXl="20" nzXXl="20">
        <nz-form-control [nzErrorTip]="">
          <textarea [nzAutosize]="{ minRows: 4, maxRows: 10 }" class="input-radius body-font-size" nz-input
            formControlName="feedback"></textarea>
        </nz-form-control>
      </nz-form-item>
    </div>
    <nz-form-item class="mt-30">
      <nz-form-control [nzSpan]="12" class="pr-2">
        <div class="btn-wrapper" style="text-align: right;">
          <div class="btn-styles btn-blue text-center" id="btn-submit" (click)="save()">
            <div class="txt">
              <button type="button" class="body-font-size">ส่ง</button>
            </div>
          </div>
        </div>
      </nz-form-control>
      <nz-form-control [nzSpan]="12">
        <div class="btn-wrapper" style="text-align: left;">
          <div class="btn-styles btn-orange text-center" id="btn-reset" (click)="clear()">
            <div class="txt">
              <button type="button" class="body-font-size">{{'P0000.P0007' | translate}}</button>
            </div>
          </div>
        </div>
      </nz-form-control>
    </nz-form-item>
  </form>
</div>